import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToolConfigParam, ToolConfigWebsiteSearch } from '@shared/index';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Menu, MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { SkillIdInputComponent } from 'src/app/shared/components/ai-bot/utils/skill-id-input/skill-id-input.component';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { FunctionNameSuggestComponent } from "../../../../../../../shared/components/ai-bot/utils/function-name-suggest/function-name-suggest.component";
import { HintComponent } from "@shared-angular/components/hint/hint.component";
import { DividerModule } from 'primeng/divider';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'app-online-sources-tab-detail',
  imports: [NgClass, NgTemplateOutlet, 
    FormsModule,
    SkillIdInputComponent,
    HintComponent,
    FunctionNameSuggestComponent,
    DividerModule,
    ToggleSwitchModule,
    InputGroupModule,
    InputGroupAddonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ButtonModule,
    SelectModule,
    MessageModule,
    TableModule,
    MenuModule
  ],
  templateUrl: './online-sources-tab-detail.component.html',
  styleUrl: './online-sources-tab-detail.component.scss'
})
export class OnlineSourcesTabDetailComponent {
  public readonly selectedToolId = input<string>('');
  public readonly closeDrawer = output();

  public selectedParamIndex: number = -1;
  public paramForNewForm?: ToolConfigParam;

  constructor(
    private toastr: ToastrService,
    public rss: RouteShareService
  ) { }

  public selectEmptyParam() {
    this.selectedParamIndex = -1;
    this.paramForNewForm = { key: '', description: '', required: true, type: 'string' };
  }

  public addParamToList() {
    if (this.paramForNewForm === undefined) return;
    this.selectedTool?.params.unshift(this.paramForNewForm);
    void this.rss.saveBotConfigField('toolConfigs');
    this.paramForNewForm = undefined;
  }

  public isParamValid(): boolean {
    if (this.selectedParam?.key.trim() == '') return false;
    if (this.selectedParam?.description.trim() == '') return false;
    return true;
  }


  public formularModelChange() {
    // soll nicht ausgeführ werden wenn wir ein "neues" Element hinzufügen
    // da tut das der button
    if (this.getSelectedParamState() === "new") return;
    if (!this.isParamValid()) { return; }
    void this.rss.saveBotConfigField('toolConfigs');
  }

  public getSelectedParamState() {
    if (this.selectedTool && this.selectedParam) {
      if (this.selectedTool.params.includes(this.selectedParam)) {
        return "existing";
      } else {
        return "new";
      }
    }
    return "new";
  }

  public get selectedTool(): ToolConfigWebsiteSearch | undefined {
    return this.toolConfigs.find(tc => tc.id === this.selectedToolId());
  }

  public get selectedParam(): ToolConfigParam | undefined {
    return this.selectedTool?.params[this.selectedParamIndex];
  }

  public get toolConfigs(): ToolConfigWebsiteSearch[] {
    return this.rss.botConfig.toolConfigs.filter(tc => tc.tool === 'websitesearch' || tc.tool === 'schnittstelle') as ToolConfigWebsiteSearch[];
  }

  public deleteParamFromList(index: number) {
    this.selectedTool?.params.splice(index, 1);
    this.saveToolConfig();
  }

  public updateToolConfigItem(id: string) {
    const index = this.rss.botConfig.toolConfigs.findIndex((tc) => {
      return tc.id === id;
    });
    const toolIndex = this.toolConfigs.findIndex((tc) => {
      return tc.id === id;
    });
    if (this.toolConfigs[toolIndex] && this.toolConfigs[toolIndex].url.trim() !== '' && this.toolConfigs[toolIndex].description.trim() !== '') {
      this.rss.botConfig.toolConfigs[index] = this.toolConfigs[toolIndex];
      void this.rss.saveBotConfigField('toolConfigs');
    } else {
      this.toastr.error("SAVED", 'Die neue Konfiguration ist nicht vollständig');
    }
  }

  public saveToolConfig() {
    if (this.selectedTool === undefined) return;
    const toolIndex = this.toolConfigs.findIndex((tc) => {
      return tc.id === this.selectedTool?.id;
    });
    this.toolConfigs[toolIndex] = this.selectedTool;
    this.updateToolConfigItem(this.selectedTool.id);
  }

  public toolOptions = [
    {
      label: $localize`:@@process-unconverted:unkonvertiert weiterverarbeiten`,
      value: 'schnittstelle'
    },
    {
      label: $localize`:@@convert-to-md:zu Markdown konvertieren`,
      value: 'websitesearch'
    }
  ];

  public paramContextMenuItems: MenuItem[] = [];

  public openParamMenu(event: Event, menu: Menu, index: number) {
    this.selectedParamIndex = -1;
    this.paramForNewForm = undefined;
    this.paramContextMenuItems = this.buildParamMenuItems(index);
    menu.toggle(event);
  }

  private buildParamMenuItems(index: number): MenuItem[] {
    return [
      {
        label: $localize`:@@edit:Bearbeiten`,
        icon: 'ri ri-pencil-fill',
        command: () => {
          this.selectedParamIndex = index;
          this.paramForNewForm = undefined;
        }
      },
      {
        label: $localize`:@@delete:Löschen`,
        icon: 'ri ri-close-large-fill',
        command: () => { this.deleteParamFromList(index); }
      }
    ];
  }
}
